import { Outlet } from 'react-router-dom';

export const InputsOutlet = () => <Outlet />;
